import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import type { ReactNode } from 'react'

interface PublicRouteProps {
  children: ReactNode
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const [searchParams] = useSearchParams()

  if (isLoading) {
    return <div>Loading...</div>
  }

  // 이미 로그인되어 있으면 원래 가려던 페이지 또는 메인 페이지로
  if (isAuthenticated) {
    // next 파라미터(Django 미들웨어 호환): React Router 가 모르는 서버 path 일 수 있으므로
    // full navigation 으로 서버까지 보내야 미들웨어가 처리 (예: /analyze → 게이트)
    const next = searchParams.get('next')
    if (next && next.startsWith('/') && !next.startsWith('//')) {
      window.location.href = decodeURIComponent(next)
      return null
    }
    // returnUrl(레거시): React 내부 라우트라 가정, 클라이언트 사이드 navigate
    const returnUrl = searchParams.get('returnUrl')
    const redirectTo = (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//'))
      ? decodeURIComponent(returnUrl)
      : '/orders'
    return <Navigate to={redirectTo} replace />
  }

  // 로그인되지 않았으면 children (로그인 페이지) 표시
  return <>{children}</>
}
